import { Directive, EventEmitter, Input, Output } from '@angular/core'
import { map, switchMap } from 'rxjs/operators'
import { AuthService, BaseSiteService } from '@spartacus/core'
import { MbLogoutService } from '../../../../shared/services/mb-logout/mb-logout.service'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Directive()
export abstract class MbCategoryNavigationToolsComponent {

  @Output() sendGTMEvent = new EventEmitter<Event>()
  @Output() searchClick = new EventEmitter<void>()
  @Output() contactClick = new EventEmitter<Event>()
  @Output() mobileMenuClick = new EventEmitter<void>()
  @Input() showSearch = false

  supportsAccountCreation$ = this.baseSiteService.get().pipe(
    map(activeBaseSite => !!activeBaseSite?.supportingAccountCreation))

  supportsGuestCheckout$ = this.baseSiteService.get().pipe(
    map(activeBaseSite => !!activeBaseSite?.supportingGuestCheckout))

  userIsLoggedIn$ = this.logoutService.logout$.pipe(
    switchMap(() => this.authService.isUserLoggedIn()))

  constructor (private baseSiteService: BaseSiteService,
               private logoutService: MbLogoutService,
               private authService: AuthService) {
  }

  protected readonly cmsLinkType = CmsLinkType
}
